/**
 * The one formatting interface (#987): text and options in, the formatted text
 * and the hunks that produce it out. The worker runs it; so does the main thread
 * where there is no worker (tests, a browser that refuses one).
 */
import { formatDocument, type FormatResult } from './format-document.js'
import type { FormatConfig } from './format-config.js'
import { formatHunks, type TextHunk } from './format-hunks.js'

export interface FormatRequest {
  text: string
  language: string | undefined
  fileName?: string
  config?: FormatConfig
}

export type FormatOutcome =
  | (Extract<FormatResult, { ok: true }> & { hunks: TextHunk[] })
  | Extract<FormatResult, { ok: false }>

export async function formatAndDiff({ text, language, fileName, config }: FormatRequest): Promise<FormatOutcome> {
  const result = await formatDocument(text, language, { fileName, config })
  return result.ok ? { ...result, hunks: formatHunks(text, result.text) } : result
}
